import type { MetaAction } from 'modules/global/generic.types';

import * as actionTypes from './actionTypes';
import type {
  AbstractInternalCommandAction,
  ConnectionSuccessAction,
  ConnectSocketAction,
  PutSocketMessageAction,
  SendMessageAction,
  SocketClosedAction,
  SocketDataResponse,
  SocketErrorAction,
  SocketMessage,
  SocketResponse,
  SubscribeTopicAction,
  UnsubscribeTopicAction,
} from './types/actions';

export const connectionSuccess = (payload?: undefined, meta: MetaAction = {}): ConnectionSuccessAction => ({
  type: actionTypes.CONNECTED,
  payload,
  meta,
});

export const socketError = (payload: string | Error | Event, meta: MetaAction = {}): SocketErrorAction => ({
  type: actionTypes.ERROR,
  payload,
  error: true,
  meta,
});

export const socketClosed = (payload?: undefined, meta: MetaAction = {}): SocketClosedAction => ({
  type: actionTypes.CLOSED,
  payload,
  meta,
});

export const connectSocket = (payload?: undefined, meta: MetaAction = {}): ConnectSocketAction => ({
  type: actionTypes.CONNECT,
  payload,
  meta,
});

export const sendMessage = (payload: SocketMessage, meta: MetaAction = {}): SendMessageAction => ({
  type: actionTypes.SEND,
  payload,
  meta,
});

export const abstractInternalCommand = (type: string, meta: MetaAction = {}): AbstractInternalCommandAction => ({
  type: `${actionTypes.ROOT}/${type.toUpperCase()}`,
  meta,
});

export const subscribe = (topic: string, payload: object, meta: MetaAction = {}): SubscribeTopicAction => ({
  type: `${actionTypes.ROOT}/TOPIC:${topic.toUpperCase()}/SUBSCRIBE`,
  payload,
  meta,
});

export const unsubscribe = (
  topic: string,
  payload?: object,
  meta: MetaAction = {},
): UnsubscribeTopicAction => ({
  type: `${actionTypes.ROOT}/TOPIC:${topic.toUpperCase()}/UNSUBSCRIBE`,
  payload,
  meta,
});

export const putSocketMessage = <U extends SocketDataResponse = SocketDataResponse>(
  response: SocketResponse<U>,
  meta: MetaAction = {},
): PutSocketMessageAction<U> => {
  const { topic, entityType, action } = response;
  return {
    type: actionTypes.actionTypeFormatter(topic, entityType, action),
    payload: response,
    meta,
  };
};
